import styled from '@emotion/styled';

export const ExportButton = styled.button<{ $showSpacer?: boolean; $loading?: boolean }>`
  display: flex;
  width: 150px;
  align-items: center;
  font-family: Inter;
  padding: 0px 10px;
  font-size: 14px;
  color: ${({ theme }): string => theme.GREY_7};
  ${({ $showSpacer, theme }): string => ($showSpacer ? `border-left: 1px solid ${theme.GREY_4}` : '')};
  & > svg {
    padding-right: 4px;
  }
  ${({ $loading }): string | undefined =>
    $loading
      ? `
  pointer-events: none;
  opacity: 0.4;
        `
      : undefined};
`;
